import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProcessoArquivoService } from '@app/services/processo-arquivo.service';
import { ProcessoArquivo } from '@app/models/processo-arquivo.model';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

@Component({
  selector: 'app-solicitacoes-pastas',
  templateUrl: './solicitacoes-pastas.component.html',
  styleUrls: ['./solicitacoes-pastas.component.scss']
})
export class SolicitacoesPastasComponent implements OnInit {

  bsModalRef: BsModalRef;

  processoId: number;
  lstProcessoArquivo: Array<ProcessoArquivo> = [];

  btnAtivo = 'S';
  constructor(
    private route: ActivatedRoute,
    @Inject(ToastrService) public toastr: ToastrService,
    private processoArquivoService: ProcessoArquivoService,
    private modalService: BsModalService,
  ) {

  }

  ngOnInit() {
    this.route.parent.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        this.obterMovimentacao();
      });
  }

  obterMovimentacao() {
    this.processoArquivoService.obterSolicitacoesPastas().toPromise().then((data) => this.lstProcessoArquivo = data);
  }

  encaminharPasta(id: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente entregar a pasta?';
    this.bsModalRef.content.confirmar = () => {
      this.processoArquivoService.encaminharPasta(id).toPromise().then((data) => {
        this.toastr.success('Pasta entregue com sucesso');
        this.obterMovimentacao();
      },
        (erro) => this.toastr.error(erro.errors));
    };
  }

  cancelar(id: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente cancelar solicitação?';
    this.bsModalRef.content.confirmar = () => {
      this.processoArquivoService.cancelar(id).toPromise().then((data) => {
        this.toastr.success('Cancelado com sucesso');
        this.obterMovimentacao();
      },
        (erro) => this.toastr.error(erro.errors));
    };
  }

  solcitacoes() {
    this.btnAtivo = 'S';
    this.obterMovimentacao();
  }

  foraDoArquivo() {
    this.btnAtivo = 'F';
    this.processoArquivoService.obterPastasForaDoArquivo().toPromise().then((data) => this.lstProcessoArquivo = data);
  }
}
